export default "__VITE_ASSET__C1xpiDPk__"